// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__iR8wZ","textarea":"styles_textarea__2Xt9o"};